export const FIXED_BASE = { REGULAR: 2, VIP: 3, EMPLOYEE: 2 };
export const SAMPLE_ID = { REGULAR: "REG-00K0M1", VIP: "VIP-0R00T1", EMPLOYEE: "EMP-00A0B1" };

export function typeText(t) {
  if (t === "VIP") return "text-rose-400";
  if (t === "EMPLOYEE") return "text-amber-400";
  return "text-teal-400";
}

export function typeBadge(t) {
  if (t === "VIP") return "bg-rose-500/20 text-rose-300 border border-rose-500/30";
  if (t === "EMPLOYEE") return "bg-amber-500/20 text-amber-300 border border-amber-500/40";
  if (t === "REGULAR") return "bg-teal-500/20 text-teal-300 border border-teal-500/30";
  return "bg-slate-700 text-slate-300";
}
